import { useState, useEffect } from "react"
import { FaHeartCircleXmark } from "react-icons/fa6";
import { RiHeartsFill } from "react-icons/ri"
import { toggleFollowWriter } from "../../../redux/naray8/naray8Action";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";

function FollowButton({ author, className, onFollowChange }) {
    const { userId, isFollowing: propIsFollowing } = author ?? {}
    const queryClient = useQueryClient();
    const [loading, setLoading] = useState(false);
    
    // BUG #4 FIX: Also check Redux store for follow status
    const followingUsers = useSelector((state) => state.user?.followingUsers || []);
    const reduxIsFollowing = followingUsers.includes(userId);
    
    // Use prop isFollowing, fallback to Redux status
    const [following, setFollowing] = useState(
        propIsFollowing !== undefined ? propIsFollowing : reduxIsFollowing
    );

    // Sync following state when props or Redux changes
    useEffect(() => {
        const newStatus = propIsFollowing !== undefined ? propIsFollowing : reduxIsFollowing;
        setFollowing(newStatus);
    }, [propIsFollowing, reduxIsFollowing]);

    const toggleFollow = async () => {
        if (!userId) return;
        
        try {
            setLoading(true)
            const followResponse = await toggleFollowWriter(userId)
            setFollowing(followResponse);
            
            // Notify parent component about the change
            if (onFollowChange) {
                onFollowChange(followResponse);
            }
            
            // Invalidate all relevant queries to refresh data
            queryClient.invalidateQueries({ queryKey: ["naray8", "writer", "followers", userId] });
            queryClient.invalidateQueries({ queryKey: ["naray8", "story", "details"] });
            queryClient.invalidateQueries({ queryKey: ["naray8", "chapter", "user", userId] });
            
            toast.success(followResponse ? "Following author!" : "Unfollowed author");
        }
        catch (error) {
            toast.error("Failed to update follow status. Please try again.")
            console.error("Follow error:", error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <button
            onClick={toggleFollow}
            disabled={loading}
            className={`px-5 py-2 flex items-center justify-center rounded-[5px] bg-customDark text-white hover:bg-[#4A4A45] gap-1.5 disabled:opacity-50 ${className}`}
        >
            {following ? <FaHeartCircleXmark size={18} className="text-[#BE9524]" /> : <RiHeartsFill size={18} className="text-[#BE9524]" />}
            <span className="text-[12px] font-medium font-outfit">{following ? "Unfollow" : "Follow"}</span>
        </button>
    )
}

export default FollowButton